import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Aritech.css'
import aritechHero from "../../../assets/images/AriTech Integration.png";
import aritechSolutions from "../../../assets/images/AriTech Integration.png";

const AritechPage = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Aritech Solutions – BuddyTech Solutions </title>
        <meta name="description" content="Advanced architectural-engineering integration for precision planning and execution." />
        <meta name="keywords" content="architectural engineering, Revit" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Aritech Solutions – BuddyTech Solutions" />
        <meta property="og:description" content="Advanced architectural-engineering integration for precision planning and execution." />
        <meta property="og:keywords" content="architectural engineering, Revit" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/constructions/aritech" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Aritech Solutions – BuddyTech Solutions" />
        <meta name="twitter:description" content="Advanced architectural-engineering integration for precision planning and execution." />
        <meta name="twitter:keywords" content="architectural engineering, Revit" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="aritech-container">
        <header className="aritech-hero">
          <div className="aritech-hero-content">
            <h1>Aritech Construction Solutions</h1>
            <p>
              We provide advanced construction technology solutions for structural planning, project optimization, and efficient execution.
            </p>
          </div>
          <img src={aritechHero} alt="Aritech Hero" className="aritech-hero-img" />
        </header>

        <section className="aritech-section">
          <div className="aritech-text">
            <h2>What We Offer</h2>
            <p>
              Aritech integrates architectural precision with engineering innovation to deliver custom-tailored solutions in modern construction.
            </p>
            <ul>
              <li>Architectural Planning & Elevation Design</li>
              <li>Structural Drawing & Detailing</li>
              <li>AutoCAD & Revit 3D Modeling</li>
              <li>Smart Layout & Planning Reports</li>
              <li>Execution Guidelines & Documentation</li>
            </ul>
          </div>
          <img src={aritechSolutions} alt="Aritech Solutions" className="aritech-img" />
        </section>

        <section className="aritech-tools">
          <h2>Tools & Platforms We Use</h2>
          <div className="tools-grid">
            <span>AutoCAD</span>
            <span>Revit</span>
            <span>SketchUp</span>
            <span>Navisworks</span>
            <span>3ds Max</span>
            <span>Lumion</span>
            <span>Excel</span>
            <span>Bluebeam</span>
          </div>
        </section>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:vinujaya.v7@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/917010658911" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+917010658911">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default AritechPage;